<template>
  <div>
    <v-row :style="`height:${frameHeight}px;`" class="mt-0">
      <v-col cols="12" md="3" class="primary pa-0 d-none d-md-block">
      </v-col>
      <v-col cols="12" md="6"  class="pa-0 elevation-0 align-center primary">
        <v-card class="align-center pa-2 pt-12 elevation-0" color="primary" >
          <v-card class="text-center py-5 elevation-2 align-center">
            <img v-if="site.logo" :src="site.logo" height="70" alt="">
            <span v-if="!site.logo" class="headline">{{site.name}}</span>
          </v-card>
          <v-card-text class="text-center">
            <v-form>
              <v-text-field
                :label="i18n.pin"
                solo
                :name="getRandom()"
                :id="getRandom()"
                autocomplete="disabled"
                v-model="pin"
                @keypress="isNumber($event)"
                :type="fieldTypes.password"
              ></v-text-field>
              <v-text-field
                :label="i18n.pinRepeat"
                solo
                :name="getRandom()"
                :id="getRandom()"
                autocomplete="disabled"
                v-model="pin2"
                @keypress="isNumber($event)"
                :type="fieldTypes.password2"
              ></v-text-field>
              <v-text-field
                :label="i18n.pinNew"
                solo
                :name="getRandom()"
                :id="getRandom()"
                autocomplete="disabled"
                v-model="pin3"
                @keypress="isNumber($event)"
                :type="fieldTypes.password3"
              ></v-text-field>
            </v-form>
            <span v-if="error" :class="`${ arabic ? 'arFont' : '' } error--text`">{{ i18n[error] }}</span>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="changePin()" large :loading="loading" :class="`${arabic?'arFont':'enFont'}`">{{i18n.changePin}}</v-btn>
          </v-card-actions>
          
        </v-card>
      </v-col>
      
      <v-col cols="12" md="3" class="primary pa-0 d-none d-md-block">
        
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {firebase, db, auth} from '@/fb'
import axios from 'axios';
const headers = {'Accept': 'application/json'};
import { getRandomInt, randomString, getCDate, check, sleep } from '@/customFunction';

export default {
  data: () => ({
    frameHeight:0,
    loading: false,
    error:null,
    pin:null,
    pin2:null,
    pin3:null,
    dialog:false,
    fieldTypes:{
      password:'text',
      password2:'text',
      password3:'text',
    }
  }),

  methods: {
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode != 45 && charCode != 46 &&
      !(charCode >= 48 && charCode <= 57)) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    goTo(path) {
      this.$router.push(path)
    },
    setCookie(name, value, days) {
      var expires = "";
      var maxAge = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
        maxAge = "; max-age=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    },
    getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    },
    getRandom(){
      return randomString(22, '#Aa')
    },
    resetError(){
      clearTimeout(this.errorTimeOUt)
      this.errorTimeOUt = setTimeout(x=>{ this.error = null }, 4000)
    },
    async changePin() {
      this.loading = true
      if(this.pin != this.pin2) {
        this.$emit('snackbarNotification', `Please Check Again`, 'error')
        this.loading = false
        return true

      }
      if(this.pin == this.pin3) {
        this.$emit('snackbarNotification', `New pin must be new`, 'error')
        this.loading = false
        return true
      }
      if(this.pin3.length < 6) {
        this.$emit('snackbarNotification', `Pin is too short`, 'error')
        this.loading = false
        return true
      }
      let data = {
        pin:this.pin,
        confirm:this.pin2,
        new:this.pin3
      }
      let a = await axios.post(`${this.api}/users/pin/change`, data, headers).then(x=>x.data)
      console.log(a)
      if(a.status) {
        this.$emit('snackbarNotification', `Pin Changed`, 'success')
      } else {
        this.$emit('snackbarNotification', `Failed | ${a.error}`, 'error')
      }
      this.pin = null
      this.pin2 = null
      this.pin3 = null
      this.loading = false
    },
    verifyCaptcha() {
      console.log(this.captchaCheck)
      console.log(this.captcha)
      if( this.captcha == this.captchaCheck ) {
        this.cap = false
        this.captchaCheck = null
        this.captcha  = null
        this.user.email  = null
        this.user.password  = null
      } else {
        this.captchaCheck = null
        this.captcha  = null
        this.error = 'wrong_captcha'
        this.$emit('snackbarNotification', `${this.i18n['wrong_captcha']}`, 'error')
        this.resetError()
        this.CreateCaptcha()
      }
    },
    CreateCaptcha() {
      var alpha = new Array('A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9');
      var i;
      for (i = 0; i < 6; i++) {
        var a = alpha[Math.floor(Math.random() * alpha.length)];
        var b = alpha[Math.floor(Math.random() * alpha.length)];
        var c = alpha[Math.floor(Math.random() * alpha.length)];
        var d = alpha[Math.floor(Math.random() * alpha.length)];
        var e = alpha[Math.floor(Math.random() * alpha.length)];
        var f = alpha[Math.floor(Math.random() * alpha.length)];
      }
      let cd = a + ' ' + b + ' ' + c + ' ' + d + ' ' + e + ' ' + f;
      this.captchaCheck = cd.split(' ').join('')
      let ac = document.getElementById('CaptchaImageCode')
      var c = document.getElementById("CapCode")
      var ctx = c.getContext("2d"),
          x = c.width / 2,
          img = new Image();
      
      img.src = "/pattern.jpg";
      img.onload = function () {
          var pattern = ctx.createPattern(img, "repeat");
          ctx.fillStyle = pattern;
          ctx.fillRect(0, 0, c.width, c.height);
          ctx.font="46px Roboto Slab";
          ctx.fillStyle = '#ccc';
          ctx.textAlign = 'center';
          ctx.setTransform (1, -0.12, 0, 1, 0, 15);
          ctx.fillText(cd,x,55);
      };
    },
    enLanguage(){
      this.$emit('changeLang', 'en')
    },
    arLanguage(){
      this.$emit('changeLang', 'ar')
    },
    switchLanguage(l) {
      this.$store.state.language = l
      if(l=='ar') {
        this.$vuetify.rtl = true
      } else {
        this.$vuetify.rtl = false
      }
    },
    setH(){
      let h = window.innerHeight
        || document.documentElement.clientHeight
        || document.body.clientHeight;
      this.frameHeight = h
    },
  },
  props: {
    
  },
  watch:{
    api(){}
  },
  computed:{
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    api(){
      return this.$store.state.settings.apiBase
    }
  },
  created(){
    
  },
  mounted(){
    this.setH()
  }

};
</script>
<style scoped lang="css">
  #login {
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
  }
</style>
